<ems-confirm-message #confirmationMessage></ems-confirm-message>

<div class="rule-heading sdps-p-bottom_small">Rule Type</div>

<div class="step-border-box sdps-p-around_large select-rule-type">
  <form [formGroup]="createRuleForm">
    <!-- Rule Name Textbox -->
      <div class="sdps-grid-container sdps-wrap" *ngIf="!isRbsBU">
        <div class="sdps-row">
          <div class="rule-type-textbox col-6" [ngClass]="{'invalidField': ((createRuleForm.get('ruleName').value && createRuleForm.get('ruleName').invalid)),
          'ruleWarning': (createRuleForm.get('ruleName').value && (ruleNameExists && !sharedService.closeToast))}">
            <p-floatlabel variant="in">
              <input type="text" name="ruleName" id="ruleName" [maxlength]="100" formControlName="ruleName" #focusName
                     emsAlphaNumericSpecialCharacterValidation emsCharacterLimit
                     [charMaxLimit]="commonConstants.charLimitValues.hundredMaxLimit"
                     (emsCharacterLimitCheck)="showCharLimit = $event" pInputText />
                <label for="ruleName" [ngClass]="{'ruleNameWarningColor': (createRuleForm.get('ruleName').value && (ruleNameExists && !sharedService.closeToast))}">
                  {{getConstant.rulesConstant.ruleNameLbl}}
                  <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
                </label>
            </p-floatlabel>
          </div>
        </div>
          <p class="col-6 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small" *ngIf="createRuleForm.get('ruleName')?.value.trim()?.length > showCharLimit">{{getConstant.rulesConstant.characterLimit}}
            <span class="character-limit">{{createRuleForm.get('ruleName').value.trim().length}}/{{commonConstants.charLimitValues.hundredMaxLimit}}</span>
          </p>
      </div>

    <div class="sdps-grid-container">
      <div class="col-full rule-type-radio sdps-p-top_medium">
        <!-- Rule Type Radio button -->
        <div class="heading">
          <strong [innerHTML]="getConstant.rulesConstant.ruleType"></strong>
          <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
        </div>
        <div class="emtr-radio sdps-grid-container sdps-m-around_none sdps-p-vertical_large col-8" [ngClass]="(disableRuleType ? 'on-select':'on-unselect')">
          <div class="col-3">
            <p-radioButton inputId="rulesCategory-restriction" name="rulesCategory" value="RESTRICT_LST_ENG"
              formControlName="rulesCategory"></p-radioButton>
            <label for="rulesCategory-restriction" class="sdps-p-left_x-small">Restriction</label>
          </div>
          <div class="col-3">
          <p-radioButton inputId="rulesCategory-watchlist" name="rulesCategory" value="WATCH_LST_ENG" formControlName="rulesCategory"></p-radioButton>
          <label for="rulesCategory-watchlist" class="sdps-p-left_x-small">Watchlist</label>
        </div>
        <div class="col-3">
          <p-radioButton inputId="rulesCategory-override" class="col-3" name="rulesCategory" value="Override" formControlName="rulesCategory"></p-radioButton>
          <label for="rulesCategory-override" class="sdps-p-left_x-small">Override</label>
        </div>
        <div class="col-3" *ngIf="this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.manageGlobalRule.uuid, '', '') && (this.businessUnit === sharedConstant.rbsBUText || this.businessUnit === '')">
          <p-radioButton inputId="rulesCategory-super-restrict" class="col-3" name="rulesCategory" value="SUPER_RESTRICT" label="Super Restriction" formControlName="rulesCategory"></p-radioButton>
          <label for="rulesCategory-super-restrict" class="sdps-p-left_x-small">Super Restriction</label>
        </div>
        </div>

        <!-- Sub-type Radio button -->
        <div class="heading">
          <strong [innerHTML]="getConstant.rulesConstant.subTypeLbl"></strong>
          <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
        </div>
        <div class="emtr-radio sdps-grid-container sdps-m-around_none sdps-p-vertical_large col-8" [ngClass]="(disableRuleType ? 'on-select':'on-unselect')">
          <div class="col-3">
          <p-radioButton inputId="ruleType-indsec" class="col-3" name="ruleType" value="INDSEC" formControlName="ruleType"></p-radioButton>
          <label for="ruleType-indsec" class="sdps-p-left_x-small">Individual Security</label></div>
          <div class="col-3">
          <p-radioButton inputId="ruleType-sectyp" class="col-3" name="ruleType" value="SECTYP" formControlName="ruleType"></p-radioButton>
          <label for="ruleType-sectyp" class="sdps-p-left_x-small">Security Type</label></div>
          <div class="col-3" [ngClass]="((createRuleForm.get('rulesCategory').value === 'WATCH_LST_ENG' || createRuleForm.get('rulesCategory').value === 'SUPER_RESTRICT') || disableRuleType  ? 'on-select':'on-unselect')">
          <p-radioButton inputId="ruleType-fndfmly" class="col-3" name="ruleType" value="FNDFMLY" formControlName="ruleType"
                         [disabled]="(createRuleForm.get('rulesCategory').value === 'WATCH_LST_ENG' || createRuleForm.get('rulesCategory').value === 'SUPER_RESTRICT')"   *ngIf="!is10b5Client"></p-radioButton>
          <label *ngIf="!is10b5Client" for="ruleType-fndfmly" class="sdps-p-left_x-small">Fund Family</label></div>
        </div>


        <!-- Justification for Override -->
          <div *ngIf="createRuleForm.get('rulesCategory').value === 'Override'">
            <p class="heading">
              <strong [innerHTML]="getConstant.rulesConstant.ruleGlobalConst.justification"></strong>
            </p>
            <div class="emtr-radio sdps-grid-container sdps-m-around_none sdps-p-vertical_small col-8">
              <div class="sdps-m-around_none sdps-p-left_small sdps-p-top_medium" *ngFor="let justification of sharedConstant[businessUnit ? businessUnit : 'RBS'].overrideJustification; let i = index">
              <div class="col-2">
                <p-radioButton [inputId]="'justification-' + i" class="sdps-p-top_small radio-button" name="justification" [value]="justification" formControlName="justification"></p-radioButton>
                <label [for]="'justification-' + i" class="sdps-p-left_x-small" [innerHTML]="justification"></label>
              </div>
              </div>
              <span class="col-3 p-float-label rule-type-textbox sdps-p-around_small sdps-m-left_small" [ngClass]="{'input-disabled': createRuleForm.value.justification !== 'Other'}">
                  <input type="text" name="others" maxlength="35" formControlName="otherInput" #otherinput aria-label="Other justification" pInputText />
                </span>
            </div>
          </div>

           <!-- Global Rule -->
        <div class="heading sdps-grid-container sdps-m-around_none col-8 sdps-p-top_medium" *ngIf="this.globalCheckboxValidation()">
          <div class="col-3 sdps-p-left_none">
          <strong [innerHTML]="getConstant.rulesConstant.globalRuleLbl"></strong>
          <span class="sdps-m-left_large">
            <label for="globalRule" class="sr-only" [innerHTML]="getConstant.rulesConstant.globalRuleLbl"></label>
            <p-checkbox class="emtr-checkbox" inputId="globalRule" name="globalRule" value="true" formControlName="globalRule" binary="true"
                        [disabled]="isEditMode || isGlobalCreateFlow"></p-checkbox>
          </span>
        </div>
        <div class="col-3" *ngIf="createRuleForm.get('globalRule')?.value && sharedService.checkEntitlements(entitlementConst.navUUID.ngOMS.manageGlobalRuleObp.uuid,'','') && !this.showOBPCheckbox && createRuleForm.get('rulesCategory')?.value === 'RESTRICT_LST_ENG' && createRuleForm.get('ruleType').value !== 'INDSEC'">
          <span class="sdps-align-items_center">
            <p-checkbox class="emtr-checkbox" inputId="openBrokeragePlan" name="openBrokeragePlan" value="true" formControlName="openBrokeragePlan"
              binary="true"></p-checkbox>
            <label for="openBrokeragePlan" class="sdps-p-left_x-small" [ngClass]="{'labelDisabled': isEditMode || toEnableOpenBrokeragePlan}">{{sharedConstant.openBrokerage.openBrokeragePlanLbl}}</label>
          </span>
        </div>
        </div>

        <!-- 10b51 / Special Blackout checkbox and PlanId Textbox -->
        <div *ngIf="(createRuleForm.get('rulesCategory').value === 'RESTRICT_LST_ENG' && (is10b5Client || isBlackoutEligible) && !isEditMode) ||
          (isEditMode && (createRuleForm.get('enable10b5Checkbox').value || createRuleForm.get('enableSpecialBlackoutCheckbox').value))">
          <p class="heading">
            <strong [innerHTML]="getConstant.rule10b5Msg.restrictionCategoryTxt"></strong>
          </p>
          <div class="emtr-radio sdps-grid-container sdps-m-around_none col-8 sdps-p-top_small">
            <!-- 10b5-1 (with Plan ID to its right) aligned under the 'Individual Security' column -->
            <div class="col-3 sdps-flex plan-id-inline">
              <div class="sdps-p-top_small"
                   *ngIf="isTenB5CheckboxVisible">
                <p-checkbox inputId="enable10b5Checkbox" class="emtr-checkbox" label="10b5-1" formControlName="enable10b5Checkbox" (onChange)="selected10b5()" binary="true"></p-checkbox>
                <label class="sdps-p-left_x-small" aria-hidden="true">10b5-1</label>
              </div>
              <div class="sdps-display-inline-block rule-type-textbox sdps-m-left_medium"
                   [ngClass]="{'invalidField': (createRuleForm.get('planId').value && (createRuleForm.get('planId').invalid)), 'input-disabled': (isEditMode || isDraftEdit) }"
                   *ngIf="createRuleForm.get('enable10b5Checkbox').value">
                <p-floatLabel variant="in">
                  <input type="number" id="planId" onkeypress="return (event.which >= 48 && event.which <= 57 && this.value.length < 10)" [attr.disabled]="(isEditMode || isDraftEdit) ? true : null" name="planId" formControlName="planId" (blur)="removeLeadingZeroes()"
                         emsNumberPatterncheck pInputText/>
                  <label for="planId">{{getConstant.rule10b5Msg.planIdTxt}}
                    <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
                  </label>
                </p-floatLabel>
              </div>
            </div>
            <!-- Special Blackout: right column (under 'Security Type') when the 10b5-1
                 checkbox is present; moved to the left column (under 'Restriction Category')
                 via CSS order when there is no 10b5-1 checkbox -->
            <div class="col-3 sdps-p-top_small"
                 [class.sb-edit-left]="!isTenB5CheckboxVisible"
                 *ngIf="(isBlackoutEligible && !isEditMode) || (isEditMode && (createRuleForm.get('enableSpecialBlackoutCheckbox').value || isBlackoutEligible))">
              <p-checkbox inputId="enableSpecialBlackoutCheckbox" class="emtr-checkbox" [label]="sharedConstant.specialBlackout.specialBlackoutTxt" formControlName="enableSpecialBlackoutCheckbox" (onChange)="selectedSpecialBlackout()" binary="true"></p-checkbox>
              <label class="sdps-p-left_x-small" aria-hidden="true">{{sharedConstant.specialBlackout.specialBlackoutTxt}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<ems-step-wizard-buttons [disableBtn]="createRuleForm?createRuleForm.invalid || (createRuleForm.get('ruleName').value && createRuleForm.get('ruleName').value.trim().length === 0) :''" [showCancelBtn]="true" [showContinueBtn]="true" (goToNext)="goToNextStep()" (closeBtn)="cancelCreateRule()"></ems-step-wizard-buttons>
